import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueTrumbowyg from 'vue-trumbowyg'
import 'trumbowyg/dist/ui/trumbowyg.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

Vue.use(VueTrumbowyg)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.config.productionTip = false

store.subscribe((mutation, state) => {
    localStorage.setItem('store', JSON.stringify(state))
})

new Vue({
    router,
    store,
    beforeCreate () {
        this.$store.commit('initialiseStore')
    },
    render: h => h(App)
}).$mount('#app')
